import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTwoDigitDecimalNumber]'
})
export class TwoDigitDecimaNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;
    var decPart = (current + "").split(".")[1];
    if (decPart && decPart.length > 2) {
      this.el.nativeElement.value = current.slice(0, -1);
    }
  }
}
